import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import MainContainer from '@blocks/MainContainer'
import MembershipController from '@club/customer/api/MembershipController'
import { confirmation, notify } from '@helpers'
import useAuth from '@hooks/useAuth'
import useStatic from '@hooks/useStatic'
import useTitle from '@hooks/useTitle'
import { colors } from '@styles/vars'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import styled from 'styled-components'
import MemberDiscountsTable from './components/DiscountsTable'

export default function Member() {
    const { user, ...auth } = useAuth<Resources.ClubMember>()

    useTitle('Group: ' + user.membership.club.name)
    useMainTemplate({ category: "club" })

    const leave = useStatic(async () => {
        const confirmed = await confirmation('Are you sure you want to leave the group?')
        if (!confirmed) return

        await MembershipController.destroy(user.membership.club.id, user.membership.id)
        auth.set('membership', null)
        notify("You successfully left the group.")
    })

    return (
        <MainContainer heading={user.membership.club.name}>
            <Grid>
                <Grid gap="15px">
                    <Grid columns="3">
                        <Grid gap="10px">
                            <h1 className="h3">{user.membership.club.name}</h1>
                            <p>You're the member of the group. You have the opportunity to access your group's discounts. Discounts are activated automatically when you pay a salon's entry fee.</p>
                        </Grid>
                    </Grid>
                    <Grid columns="4">
                        <Grid gap="5px">
                            <small>Email</small>
                            <p style={{ color: colors.black }}><b>{user.membership.club.email}</b></p>
                        </Grid>
                        <Grid gap="5px">
                            <small>Head</small>
                            <p style={{ color: colors.black }}><b>{user.membership.club.owner.first_name} {user.membership.club.owner.last_name}</b></p>
                        </Grid>
                    </Grid>
                </Grid>
                <EmphasizedContent><MemberDiscountsTable /></EmphasizedContent>
                <Grid gap="10px">
                    <Grid gap="0px">
                        <small>Danger zone</small>
                        <hr />
                    </Grid>
                    <Grid columns="4">
                        <Grid gap="10px">
                            <h4>Leave</h4>
                            <small>You can leave the group at any time. Your data on the website won't be affected by this.</small>
                            <Button type="tertiary" width="auto" onClick={leave}>Leave the group</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </MainContainer>
    )
}

const Heading = styled.div`
    display: flex;
    align-items: center;

    > *:not(:last-child) {
        margin-right: 15px;
        margin-bottom: 0;
    }
`